import { MinimumPensionEstimatorModuleRouter } from './router';

const MinimumPensionEstimatorModule = (moduleConfig = {}) => ({
  pathBase: "/",
  componentRouter: MinimumPensionEstimatorModuleRouter,
});

export default MinimumPensionEstimatorModule;
